var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.active)?_c('div',{staticClass:"my-4"},[_vm._t("header"),_vm._v(" "),_vm._t("body"),_vm._v(" "),_vm._t("footer")],2):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }